<template>
	<div class="print-wrap-detail" v-loading="loadType" element-loading-text="数据加载中...">
		<div class="page-main">
			<div class="print-main">
				<p class="print-main-title">
					<!-- 标题 -->
					检验结果总汇表
					<el-button class="brotherBtns" @click="print" v-if="btnShow">
						<i class="iconfont icon-dayin-icon" style="color:#1BBC9B"></i>
						<span>打印</span>
					</el-button>
				</p>

				<div class="print-main-content" v-for="(item, index) in weekData">
					<div class="print-main-content-title">
						<div>日期：{{ index }}</div>
						<div>打印日期：{{ item[0].print_date }}</div>
					</div>
					<div v-for="itm in item">
						<el-table :data="itm.detail" border :span-method="objectSpanMethod" style="width: 100%">
							<el-table-column prop="staff_name" label="运动员" width="100" align="center"> </el-table-column>
							<el-table-column prop="test_item" label="代号" align="left"> </el-table-column>
							<el-table-column prop="test_xmmc" label="项目" align="left"> </el-table-column>
							<el-table-column prop="test_value" label="结果" align="left">
								<template slot-scope="scope">
									{{ scope.row.test_value }} * {{ scope.row.test_dw }} <i v-if="scope.row.test_result == 1" class="el-icon-bottom" style="color: #FF8D03;font-size: 16px;"></i
									><i v-else-if="scope.row.test_result == 3" class="el-icon-top" style="color: #FF0000;font-size: 16px;"></i
								></template>
							</el-table-column>
							<el-table-column prop="test_dyckz" label="参考值" align="left"> </el-table-column>
						</el-table>
					</div>

					<div class="print-main-content-bot"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import Template from '../../../../../../jsh-project/src/view/training/template.vue'
export default {
	name: 'print',
	data() {
		return {
			btnShow: true,

			coach_name: '',

			weekData: {},
			newWeekData: [],
			departmentName: '',

			tableList: [],

			loadType: true,
		}
	},
	created() {},
	mounted() {
		this.$axios
			.post(
				'/p/equipment_record/printAll',
				this.$qs({
					equipment_uuid: this.$route.query.deviceSelect,
					name: this.$route.query.name,
					start_date: this.$route.query.start_date,
					end_date: this.$route.query.end_date,
					department_uuid_str: this.$route.query.department_uuid_str,
					staff_uuid_str: this.$route.query.staff_uuid_str,
					model_num: this.$route.query.modelNumValue,
					brand_uuid: this.$route.query.brandValue,
					norm_uuid_str: decodeURIComponent(this.$route.query.cateType),
				})
			)
			.then(res => {
				this.weekData = this.setMapData(res.data.data.info)
				this.loadType = false
			})
	},
	methods: {
		objectSpanMethod({ row, column, rowIndex, columnIndex }, val) {
			console.log({ row, column, rowIndex, columnIndex })
			if (columnIndex === 0) {
				if (rowIndex === 0) {
					return {
						rowspan: row.length,
						colspan: 1,
					}
				} else {
					return {
						rowspan: 0,
						colspan: 0,
					}
				}
			}
		},
		print() {
			this.btnShow = false
			setTimeout(() => {
				window.print()
			}, 0)
			setTimeout(() => {
				this.btnShow = true
			}, 2000)
		},

		setMapData(cobj) {
			for (var i in cobj) {
				cobj[i].forEach(item => {
					item.detail.forEach(itm => {
						itm.staff_name = item.staff_name
						itm.length = item.detail.length
					})
				})
			}
			return cobj
		},
	},
}
</script>
<style lang="scss">
html,
body {
	width: 100%;
	height: auto !important;
	overflow: auto !important;
}
#app {
	height: auto !important;
}
.print-wrap-detail {
	width: 100%;
	height: 100%;
	overflow: auto;

	page-break-inside: avoid;
	// background: #eff1f5;
	.page-main {
		width: 850px;
		// border: 1px solid #000;
		margin: 0 auto;
		// background: #999	;
		// min-height: 100%;
		// border-left: 1px solid #ccc;
		// border-right: 1px solid #ccc;
		// background: #daeeff;
		padding-bottom: 20px;
		.print-main {
			.print-main-title {
				width: 100%;
				text-align: center;
				padding-top: 30px;
				font-size: 35px;
				font-weight: 500;
				position: relative;
				color: #000;
				// background: linear-gradient(180deg, #35a2dc 0%, #1869b6 100%);
				.brotherBtns {
					position: absolute;
					top: 20px;
					right: 20px;
				}
			}
			.print-main-date {
				display: flex;
				span {
					font-size: 18px;
					display: inline-block;
					width: 50%;
					text-align: center;
				}
			}
			.print-main-content {
				// margin: 0 20px;
				padding-top: 20px;

				.print-main-content-title {
					display: flex;
					justify-content: space-between;
				}
				> h2 {
					width: 150px;
					line-height: 40px;
					font-size: 18px;
					font-weight: 400;
					// background: #1a87dd;
					color: #fff;
					text-align: center;
					border-top-left-radius: 10px;
					border-top-right-radius: 10px;
				}
				> ul {
					display: flex;
					flex-wrap: wrap;
					background: #fff;
					justify-content: space-between;
					padding: 20px 15px 0px;
					li {
						width: 48%;
						// min-height: 40px;
						border-radius: 10px;
						// border: 1px solid #1a87dd;
						margin-bottom: 20px;
						display: flex;
						align-items: center;
						strong {
							color: #dd2d1a;
							margin-right: 5px;
						}
						span {
							width: 120px;
							color: #000;
							// border-right: 1px solid #fff;
							display: flex;
							height: 100%;
							align-items: center;
							justify-content: center;
							padding: 10px 0;
							box-sizing: border-box;
							font-weight: 500;
						}
						p {
							flex: 1;
							padding: 10px 10px 10px 20px;
							display: flex;
							align-items: center;
							box-sizing: border-box;
						}
					}
				}

				.el-table {
					margin-top: 20px;
					/deep/ .el-table__header thead tr {
						background: #cfc;
					}
				}
			}

			.print-main-content-bot {
				background: #fff;
				// padding-bottom: 30px;

				.print-bot-top-content {
					width: 80%;
					margin-left: 10%;
					display: flex;
					flex-wrap: wrap;
				}

				.print-bot-top-last {
					// margin-bottom: 20px;
				}

				.print-bot-top {
					// border-radius: 10px;
					// border: 1px solid #1a87dd;
					width: 33.3%;
					// margin-bottom: 20px;
					display: flex;
					// line-height: 18px;
					align-items: center;

					&:first-child {
						p {
							text-decoration: none;
							b {
								text-decoration: underline;
								font-weight: 500;
							}
						}
					}
					strong {
						color: #dd2d1a;
						margin-right: 5px;
					}
					span {
						// width: 80px;
						// background: rgba(26, 135, 221, 0.09);
						color: #000;
						// border-right: 1px solid #1a87dd;
						display: flex;
						height: 100%;
						// align-items: center;
						// justify-content: center;
						padding: 5px 0;
						box-sizing: border-box;
						font-weight: 500;
						justify-content: start;
						font-size: 18px;
					}
					p {
						flex: 1;
						font-weight: 500;
						font-size: 17px;
						display: flex;
						align-items: center;
						box-sizing: border-box;
						word-break: break-all;
						word-wrap: break-word;
						overflow: hidden;
						// line-height: 17px;
						text-decoration: underline;
					}
				}

				.print-bot-input {
					display: flex;
					min-height: 50px;
					border: 1px solid #000;
				}

				.print-bot-input-zy {
					display: flex;
					min-height: 50px;
					width: 100%;
					.left_title {
						background: #fff;
						border: none;
					}
				}

				.table_title {
					display: flex;
					// line-height: 50px;
					// padding: 20px 0;
					border-left: 1px solid #000;
					border-top: 1px solid #000;
				}

				.left_title {
					// display: block;
					width: 70px;
					background: #fff;
					text-align: center;
					border-right: 1px solid #000;
					// font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 400;
					// color: #333333;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
					padding: 10px 15px;
					box-sizing: border-box;
					font-size: 16px;

					span {
						font-size: 14px;
					}
				}

				.right_title {
					flex: 1;
					background: #fff;
					text-align: center;
					border-right: 1px solid #000;
					// font-family: PingFangSC-Medium, PingFang SC;
					// font-weight: 300;
					// color: #333333;
					padding: 10px;
					box-sizing: border-box;
					display: flex;
					align-items: center;
					justify-content: center;
					// white-space: pre-wrap;
					word-break: break-all;
					word-wrap: break-word;
					overflow: hidden;
					text-align: justify;
					font-size: 16px;
					line-height: 23px;
				}

				.right_title_three {
					width: 90px;
					background: #fff;
					text-align: center;
					border-right: 1px solid #000;
					// font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 400;
					// color: #333333;
					padding: 10px 5px;
					box-sizing: border-box;
					display: flex;
					align-items: center;
					justify-content: center;
					// white-space: pre-wrap;
					word-break: break-all;
					word-wrap: break-word;
					overflow: hidden;
					text-align: justify;
				}

				.right_title_demo {
					width: 60px;
				}

				.table_content {
					border-top: 1px solid #000;
					.right_title {
						min-height: 18px;
						background: #fff !important;
					}
					.right_title_three {
						background: #fff !important;
					}
				}

				.right_content {
					flex: 1;
					display: flex;
					align-items: center;
					// justify-content: center;
					// font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 400;
					// color: #333333;
					padding: 20px 10px;
					// white-space: pre-wrap;
					word-break: break-all;
					word-wrap: break-word;
					font-size: 16px;
					line-height: 23px;
					text-indent: 2em;
				}

				.right_content_two {
					padding: 20px 10px;
				}
			}
		}
	}
}

.doping-top {
	position: relative;
	width: 100%;
	height: 62px;
	background: rgba(244, 246, 249, 1);
	border: 1px solid rgba(227, 227, 227, 1);
	line-height: 62px;
	box-sizing: border-box;
	padding: 0 20px;
	display: flex;
	justify-content: space-between;
}
.gzqTabStyle {
	margin-top: 30px;
	padding: 0 20px 20px;
}
.lists {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	padding: 0 20px;
	box-sizing: border-box;
	margin-top: 40px;
	li {
		font-family: MicrosoftYaHei;
		width: 33%;
		height: 30px;
		font-size: 16px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		span {
			color: #626262;
		}
	}
}
.trainContent {
	width: 100%;
	font-size: 14px;
}

.content_tips {
	padding-left: 100px;
	font-size: 17px;
	color: #000;
	padding-top: 2px;
}
</style>

<style type="text/css" media="print">
@page {
	size: portrait;
}
</style>
